import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { SearchChannelsRequestFilterSensitiveLog, SearchChannelsResponseFilterSensitiveLog, } from "../models/models_0";
import { de_SearchChannelsCommand, se_SearchChannelsCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class SearchChannelsCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "SearchChannels", {})
    .n("ChimeSDKMessagingClient", "SearchChannelsCommand")
    .f(SearchChannelsRequestFilterSensitiveLog, SearchChannelsResponseFilterSensitiveLog)
    .ser(se_SearchChannelsCommand)
    .de(de_SearchChannelsCommand)
    .build() {
}
